/**
 * Get the character from a keydown/keyup event.
 *
 * Based on: http://stackoverflow.com/a/13127566/1262753
 *
 * @param {Event} event
 * @return {string} Returns a character or an empty string
 */
export function charFromKeyCode (event) {
  if (!event.altKey && !event.ctrlKey) {
    const c = TO_ASCII.hasOwnProperty(event.keyCode)
        ? TO_ASCII[event.keyCode] // normalize keyCode
        : event.keyCode

    if (!event.shiftKey && c >= 48 && c <= 57) { // 0-9
      return String.fromCharCode(c)
    }

    if (!event.shiftKey && c >= 65 && c <= 90) { // a-z
      return String.fromCharCode(c + 32)
    }

    if (event.shiftKey && c >= 65 && c <= 90) { // A-Z
      return String.fromCharCode(c)
    }

    if (event.shiftKey && SHIFT_UPS.hasOwnProperty(c)) {
      // get shifted keyCode value
      return SHIFT_UPS[c]
    }
  }

  return ''
}

const TO_ASCII = {
  '188': '44',
  '109': '45',
  '190': '46',
  '191': '47',
  '192': '96',
  '220': '92',
  '222': '39',
  '221': '93',
  '219': '91',
  '173': '45',
  '187': '61', // IE Key codes
  '186': '59', // IE Key codes
  '189': '45'  // IE Key codes
}

const SHIFT_UPS = {
  '96': '~',
  '49': '!',
  '50': '@',
  '51': '#',
  '52': '$',
  '53': '%',
  '54': '^',
  '55': '&',
  '56': '*',
  '57': '(',
  '48': ')',
  '45': '_',
  '61': '+',
  '91': '{',
  '93': '}',
  '92': '|',
  '59': ':',
  '39': '"',
  '44': '<',
  '46': '>',
  '47': '?'
}



// WEBPACK FOOTER //
// ./src/utils/charFromKeyCode.js